module.exports = __webpack_public_path__ + "img/google.8c58d12f.svg";